import BaseWebSocketSubscriber from './base.websocket.subscriber'

const MESSAGE_TYPES = {
  PATCH_PRESENTATION: 'patch-presentation',
}

class PresentationWebSocketSubscriber extends BaseWebSocketSubscriber {
  init() {
    this.listenEvents()
  }

  listenEvents() {
    this.socketClient.on(MESSAGE_TYPES.PATCH_PRESENTATION, this.onPatchPresentation.bind(this))
  }

  onPatchPresentation(data) {
    this.$store.dispatch('patchPresentationAction', data)
  }
}

export default PresentationWebSocketSubscriber
